module.exports = __webpack_public_path__ + "static/media/compass__arrow.814894cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/404/static/img/compass__arrow.svg
// module id = 2075
// module chunks = 118